import { v4 as uuid } from "uuid";

import * as EntityReport from "../entities/contractorReport";
export type ContractorReport = EntityReport.ContractorReport;

export enum ReportStatus {
  Upcoming = "report-status_upcoming",
  InProgress = "report-status_in-progress",
  Complete = "report-status_complete",
  Overdue = "report-status_overdue",
}

export const reportStatusToColor = (reportStatus: ReportStatus) => {
  switch (reportStatus) {
    default:
    case ReportStatus.Upcoming:
      return "warning";
    case ReportStatus.InProgress:
      return "info";
    case ReportStatus.Complete:
      return "success";
    case ReportStatus.Overdue:
      return "error";
  }
};

export const reportStatusToString = (reportStatus: ReportStatus): string => {
  switch (reportStatus) {
    case ReportStatus.Upcoming:
      return "Upcoming";
    case ReportStatus.Overdue:
      return "Overdue";
    case ReportStatus.InProgress:
      return "In Progress";
    case ReportStatus.Complete:
      return "Complete";
  }
};

export type ContractorReportLineItem = {
  id: string;
  contractorId: string;
  contractorPackageId: string;
  organisationLogo: string;
  organisationName: string;
  dueDateMonth: number;
  dueDateYear: number;
  status: ReportStatus;
  created: Date;
};

export const createDefaultReport = (
  packageId: string,
  contractorId: string,
  dueDate: Date
): ContractorReportLineItem => {
  return {
    id: uuid(),
    contractorId: contractorId,
    contractorPackageId: packageId,
    status: ReportStatus.Upcoming,
    organisationLogo: "",
    organisationName: "",
    dueDateMonth: dueDate.getMonth(),
    dueDateYear: dueDate.getFullYear(),
    created: new Date(),
  };
};
